import { Component, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { take } from 'rxjs';
import { ButtonClickEvent, CacButtonComponent, CacFieldComponent } from '@controladad/ng-base';
import { formControl, formGroup, Validators } from '@al00x/forms';
import { CategoryApiService, GoogleFeedApiService } from '@core';

declare const snackbar$: any;

@Component({
  selector: 'lib-google-feed-settings',
  imports: [CommonModule, CacFieldComponent, CacButtonComponent],
  templateUrl: './google-feed-settings.component.html',
  styleUrl: './google-feed-settings.component.scss',
})
export class GoogleFeedSettingsComponent {
  private readonly googleFeedApi = inject(GoogleFeedApiService);
  private readonly categoryApi = inject(CategoryApiService);

  categoryItems$ = this.categoryApi.getFlatCategories();

  form = formGroup({
    offersCategoryId: formControl<number | undefined>(undefined, Validators.required),
  });

  isDefault = false;
  isRegenerating = signal(false);

  constructor() {
    this.googleFeedApi
      .get()
      .pipe(take(1))
      .subscribe((settings) => {
        this.isDefault = settings.isDefault;
        this.form.patchValue({ offersCategoryId: settings.offersCategoryId });
      });
  }

  isFormValid(): boolean {
    return this.form.valid;
  }

  save(e: ButtonClickEvent) {
    const offersCategoryId = this.form.value.offersCategoryId;

    if (offersCategoryId === undefined || offersCategoryId === null) {
      snackbar$.show('Please select the offers category', 'error');
      return;
    }

    this.googleFeedApi
      .set({ offersCategoryId, isDefault: false })
      .pipe(e.pipe())
      .subscribe(() => {
        this.isDefault = false;
        snackbar$.show('Google feed settings saved');
      });
  }

  regenerate(e: ButtonClickEvent) {
    if (this.isRegenerating()) {
      return;
    }

    this.isRegenerating.set(true);

    this.googleFeedApi
      .regenerate()
      .pipe(e.pipe())
      .subscribe({
        next: (result) => {
          this.isRegenerating.set(false);
          snackbar$.show(`Google feed regenerated (${result.productCount} products)`);
        },
        error: () => {
          this.isRegenerating.set(false);
          snackbar$.show('Could not regenerate the Google feed', 'error');
        },
      });
  }
}
